import {
	faHandHoldingHeart,
	faUsers,
	faClipboardList,
	faFileInvoiceDollar,
	faChartLine,
	faBuildingColumns,
	faChartColumn,
	faSackDollar,
} from '@fortawesome/free-solid-svg-icons';

export const SideNavigationItems = [
	{
		heading: '',
		items: [
			{
				label: 'Social service and impact',
				link: '/calculator/workflow-selection',
				icon: faHandHoldingHeart,
			},
			{
				label: 'Target population',
				link: '/calculator/social-service',
				icon: faUsers,
			},
			{
				label: 'Current utilization and costs',
				link: '/calculator/current-utilization',
				icon: faClipboardList,
			},
			{
				label: 'Social service costs',
				link: '/calculator/target-population',
				icon: faFileInvoiceDollar,
			},
			{
				label: 'Impact on utilization',
				link: '/calculator/healthcare-utilization',
				icon: faChartLine,
			},
			{
				label: 'Revenue implications',
				link: '/calculator/revenue-implication',
				icon: faBuildingColumns,
			},
			{
				label: 'Results: healthcare org ROI',
				link: '/calculator/summary-financial',
				icon: faChartColumn,
			},
			{
				label: 'Results: CBO revenue',
				link: '/calculator/return-on-investment',
				icon: faSackDollar,
			},
		],
	},
];
